import { render } from "./WidgetdoughnutChart.vue?vue&type=template&id=070a31f9"
import script from "./WidgetdoughnutChart.vue?vue&type=script&lang=js"
export * from "./WidgetdoughnutChart.vue?vue&type=script&lang=js"

import "./WidgetdoughnutChart.vue?vue&type=style&index=0&id=070a31f9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__